import type { BaseRowData } from '@adv-frontend/data-provider';
import type { GridRow } from '../../types';

/**
 * Возвращает массив с индексом для строки и
 * массив индексов родительских строк для подстроки
 *
 * @typeParam RowData Данные строки.
 * @param row Строка.
 * @returns Массив индексов.
 */
export function getRowIndexes<RowData extends BaseRowData>(row: GridRow<RowData>) {
    return row.depth === 0
        ? row.index
        : row
              .getParentRows()
              .map(row => row.index)
              .concat(row.index);
}
